export const MESSAGES = {
  'area-analytics-zoom-warning':
    '현재 배율에서는 {{type}} 이용할 수 없습니다.<br /><strong>지도를 좀 더 확대</strong>해주세요.',
};
